import { useEffect, useState } from "react";
import { publicApi } from "@/lib/api";

let cache = null;
let listeners = [];

export function useSite() {
  const [site, setSite] = useState(cache);

  useEffect(() => {
    if (cache) { setSite(cache); return; }
    const listener = (s) => setSite(s);
    listeners.push(listener);
    publicApi.site().then((s) => {
      cache = s;
      listeners.forEach((l) => l(s));
    }).catch(() => {});
    return () => { listeners = listeners.filter((l) => l !== listener); };
  }, []);

  return site;
}
